<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <!-- <AddressBook ref="addressBook"></AddressBook> -->
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <QrScanner ref="qrScanner" :className.sync="qrScanner.className"></QrScanner>
          <div class="relative has-text-centered">
            <div ref="step1" class="absolute full-width">
                <label class="label" v-html="$t('TagTransferBody', {qrIcon: `<i class='fa fa-qrcode'></i>`})"></label>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <div class="control has-icons-left has-icons-right">
                            <input ref="nfcId" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" v-model="nfcId" class="input" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required>
                            <span class="icon is-small is-left double">
                                <i class="fa fa-tag"></i>
                                <!-- <i @click="showContacts()" class="fa fa-address-book clickable"></i> -->
                            </span>
                            <span @click="scanQr('oldTag')" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                                <i class="fa fa-qrcode"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-arrow-right']"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="$router.go(-1)" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-times"></i>
                            </span>
                            <span>{{ $t("Cancel") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/wallet/send')" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-exchange"></i>
                            </span>
                            <span>{{ $t("SendToWallet") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/meter/topup')" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-house"></i>
                            </span>
                            <span>Send to household meter</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step2" class="absolute full-width is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("SendTo") }} </label>
                            <div class="control has-icons-left">
                                <input class="input" v-model="recipient" type="text" disabled readonly>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("Amount") }}</label>
                            <div class="control has-icons-left">
                                <input ref="amount" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Amount')" required :step="minTransfer" v-model.number="amount" :min="minTransfer">
                                <span v-html="user.wallet.currency.symbol" class="icon is-small is-left"></span>
                            </div>
                        </div>
                        <div>{{ $t("MinimumTransferBody", [this.formatCurrency(this.minimumTransfer(user.wallet.currency), user.wallet.currency)]) }}</div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <label class="label">{{ $t("Tap") }}</label>
                        <div class="control has-icons-left">
                            <div class="select is-fullwidth">
                                <select ref="asset" v-model="tag.assetId" required>
                                    <option disabled value="disabled">{{ $t("Tap")}}</option>
                                    <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID" class="status" :class="[asset.connected ? 'Connected' : 'Disconnected']">{{ asset.name }} ({{ asset.connected ? "Connected" : "Disconnected" }})</option>
                                </select>
                            </div>
                            <div class="icon is-small is-left">
                                <i class="fa fa-tint"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="send()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-exchange"></i>
                            </span>
                            <span>{{ $t("Send") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </section>
  <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
// import AddressBook from "@/components/AddressBook.vue";
import Notification from "@/components/Notification.vue";
import QrScanner from "@/components/QrScanner.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "TagTopup",
  components: {
    Header,
    Modal,
    // AddressBook,
    Notification,
    QrScanner,
    NavigationTabs,
    Spinner
  },
  props:
  {
    _nfcId: String,
    _amount: String,
    _currency: String
  },
  async mounted() {
    this.minTransfer = this.minimumTransfer(this.user.wallet.currency);
    this.amount = this.minimumTransfer(this.user.wallet.currency);

    if(this._amount && this._currency)
    {
        const response = await this.$http.get(`/Utilities/LocalCurrency?amount=${this._amount}&currencyCode=${this._currency}`);
        this.amount = response.data.amount;
    }

    if(this.nfcId)
    {
        this.next();
    }

    await this.updateUser();
  },
  computed:
  {
    recipient: function()
    {
        return `${this.tag.nfcId} (${this.tag.householdName})`;
    }
  },
  data () {
      return {
          nfcId: this._nfcId,
          tag: {},
          assets: [],
          minTransfer: 0,
          amount: 0,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons: []
          },
          qrScanner: {
              className: ""
          }
      }
  },
  methods:
  {
      updateHousehold: function(_tab)
      {
          this.$router.push({name: 'Household', params: {_householdId: this.tag.householdID, _tab}});
      },
      back: function() {
        this.$refs.step1.classList.remove("is-hidden");
        this.$refs.step2.classList.add("is-hidden");
      },
      next: async function() {
        if(!this.$refs.nfcId.checkValidity())
        {
            this.$refs.nfcId.reportValidity();
            return;
        }

        try
        {
            const response = await this.$http.get(`/Tags/Tag/${this.nfcId.toUpperCase()}`);
            this.tag = response.data.tag;

            if(this.tag.isBlacklisted)
            {
                throw new Error(this.$t("TagHasBeenBlacklisted"));
            }

            if(this.tag.householdName == "Unknown" || this.tag.numberOfPeople < 1)
            {
                this.modal.title = this.$t("UnknownHousehold");
                this.modal.body = `<p>${this.$t("UnknownHouseholdInfo")}</p>`;

                if(this.hasPermission("Household", "Edit"))
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("UpdateHousehold"), className: "is-primary", click: () => { this.updateHousehold("household") }},
                        {id: 1, title: this.$t("Cancel"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];
                }

                else if(this.user.householdID == this.tag.householdID)
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("UpdateHousehold"), className: "is-primary", click: () => { this.$router.push("/account/household") }},
                        {id: 1, title: this.$t("Cancel"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];
                }

                else
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("OK"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];    
                }

                this.modal.className = "is-active";
                return;
            }

            else if(this.tag.name == "Unknown" || this.tag.name == "Offline Tag")
            {
                this.modal.title = this.$t("UnknownTag");
                this.modal.body = `<p>${this.$t("UnknownTagInfo")}</p>`;

                if(this.hasPermission("Household", "Edit"))
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("UpdateHousehold"), className: "is-primary", click: () => { this.updateHousehold("tags") }},
                        {id: 1, title: this.$t("Cancel"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];
                }

                else if(this.user.householdID == this.tag.householdID)
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("UpdateHousehold"), className: "is-primary", click: () => { this.$router.push("/account/tags") }},
                        {id: 1, title: this.$t("Cancel"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];
                }

                else
                {
                    this.modal.buttons =
                    [
                        {id: 0, title: this.$t("OK"), className: "is-info", click: () => { this.modal.className = ""; }}
                    ];    
                }

                this.modal.className = "is-active";
                return;
            }
            
            await this.updateTaps();
            
            this.$refs.step1.classList.add("is-hidden");
            this.$refs.step2.classList.remove("is-hidden");
        }

        catch(error)
        {
            if(this.hasPermission("Household", "Edit"))
            {
                if(confirm(this.$t("ResellerRegisterTagUnknown")))
                {
                    this.$router.push('/households/register');
                }
            }

            else
            {
                alert(this.$t("RegisterUnknownTag"));
            }
        }
      },
      updateTaps: async function()
      {
        if(this.tag.waterSystemId)
        {
            const response = await this.$http.get(`/Asset?waterSystemId=${this.tag.waterSystemId}`);
            this.assets = response.data.assets;
        }
      },
      scanQr: function() {
          this.$refs.qrScanner.scanQr();
      },
      qrResult: function(result) {
        const pattern = /^[A-Fa-f0-9]{8}$/;

        if (!pattern.test(result))
        {
            alert(this.$t("ErrorQrCodeDoesntContainATagId"));
            return;
        }

        this.nfcId = result;
      },
    //   showContacts()
    //   {
    //       this.$refs.addressBook.show("tags");
    //   },
      send: function() {
        const amount = parseFloat(this.amount);

        if (isNaN(amount) || amount < parseFloat(this.minTransfer)) {
            this.$refs.amount.reportValidity();
            return;
        }

        this.modal.title = this.$t("ConfirmTransfer");
        this.modal.body = `<p>${this.$t("ConfirmTransferBody", {amount: this.formatCurrency(this.amount, this.user.wallet.currency), recipient: this.recipient})}</p>`;

        if(this.$refs.asset.selectedOptions[0].className.split(" ").indexOf("Connected") == -1)
        {
            this.modal.body += `<br><br>${this.$t("InfoTapNotOnline")}`;
        }
        
        this.modal.buttons =
        [
            {id: 0, title: this.$t("Yes"), className: "is-primary", click: this.doSend},
            {id: 1, title: this.$t("No"), className: "is-info", click: () => { this.modal.className = ""; }}
        ];

        this.modal.className = "is-active";
      },
      doSend: async function()
      {
        if(this.loading)
        {
            return;
        }

        try
        {
            const response = await this.$http.put(`/Transactions`,
            [
                {
                    currencyCode: this.user.wallet.currency.code,
                    amount: this.amount,
                    nfcid: this.nfcId.toUpperCase(),
                    assetId: this.tag.assetId
                }
            ]);
            
            console.dir(response);
            if (response.status < 200 || response.status > 299){ // failure of some kind
              this.$refs.content.scrollTo(0, 0);
              this.modal.className = "";
              this.notification = {
                show: true, className: "is-danger",
                text: response.data.message || this.$t("Error")
              }
            } else { // Success

              this.modal.className = "is-active";
              this.modal.title = this.$t("CreditSent");
              this.modal.body = this.$t("CreditSentBody", [this.formatCurrency(this.amount, this.user.wallet.currency), this.recipient]).split("\\n").join("<br><br>");

              this.modal.buttons =
                  [
                    {
                      id: 0, title: this.$t("Yes"), className: "is-primary", click: function () {
                        this.$router.go()
                      }.bind(this)
                    },
                    {
                      id: 1, title: this.$t("No"), className: "is-info", click: function () {
                        this.$router.push("/wallet/transactions")
                      }.bind(this)
                    }
                  ]

              await this.updateUser();
            }
        } catch (error) {
          console.dir(error);
          this.$refs.content.scrollTo(0, 0);
          this.modal.className = "";

          if (error.response) {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: error.response.data.message
                }
          } else {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: error.message || this.$t("Error")
                }
          }
        }
      }
  }
};
</script>
